// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "MapSection-module--wrapper--TwHAP";
export var decorator = "MapSection-module--decorator--J+sWy";
export var infoWrapper = "MapSection-module--infoWrapper--f1uDj";
export var sectionTitle = "MapSection-module--sectionTitle--8bAnE";
export var legendWrapper = "MapSection-module--legendWrapper--n1XgP";
export var buttonWrapper = "MapSection-module--buttonWrapper--fQQZk";
export var legendButtonWrapper = "MapSection-module--legendButtonWrapper--EjKXt";